var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('v-btn-toggle',{staticClass:"justify-center",attrs:{"value":_vm.value,"disabled":_vm.disabled,"dense":"","mandatory":""},on:{"change":(v) => _vm.$emit('input', v)}},[_c('v-btn',{class:{
      'white--text': _vm.value == _vm.orderTypes.OneTime,
      'grey--text text--lighten-2': _vm.darkMode && _vm.value != _vm.orderTypes.OneTime,
    },attrs:{"disabled":_vm.disabled && _vm.value != _vm.orderTypes.OneTime,"color":_vm.value == _vm.orderTypes.OneTime
        ? 'primary'
        : _vm.darkMode
        ? 'grey darken-3'
        : 'default',"value":_vm.orderTypes.OneTime}},[_vm._v(" Jednorázová ")]),_c('v-btn',{class:{
      'white--text': _vm.value == _vm.orderTypes.Repeated,
      'grey--text text--lighten-2': _vm.darkMode && _vm.value != _vm.orderTypes.Repeated,
    },attrs:{"disabled":_vm.disabled && _vm.value != _vm.orderTypes.Repeated,"color":_vm.value == _vm.orderTypes.Repeated
        ? 'primary'
        : _vm.darkMode
        ? 'grey darken-3'
        : 'default',"value":_vm.orderTypes.Repeated}},[_vm._v(" Opakovaná ")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }